module.exports = __webpack_public_path__ + "static/how-it-works-2-c49ad8ac13a77cbada2d624e37986ebe.svg";